import { render } from "./RxView.vue?vue&type=template&id=a6ef3dd8&scoped=true"
import script from "./RxView.vue?vue&type=script&lang=js"
export * from "./RxView.vue?vue&type=script&lang=js"

import "./RxView.vue?vue&type=style&index=0&id=a6ef3dd8&scoped=true&lang=css"
import "./RxView.vue?vue&type=style&index=1&id=a6ef3dd8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ef3dd8"]])

export default __exports__